import React from "react";

const FORMAT_STYLES = {
  hardcover: "bg-amber-100 text-amber-900 border-amber-200",
  paperback: "bg-orange-50 text-orange-900 border-orange-200",
  ebook: "bg-sky-100 text-sky-900 border-sky-200",
  "e-book": "bg-sky-100 text-sky-900 border-sky-200",
  audio: "bg-violet-100 text-violet-900 border-violet-200",
  audiobook: "bg-violet-100 text-violet-900 border-violet-200",
  course: "bg-purple-100 text-purple-900 border-purple-200",
  physical: "bg-stone-100 text-stone-800 border-stone-200",
};

const FORMAT_LABELS = {
  hardcover: "Hardcover (Physical)",
  paperback: "Paperback (Physical)",
  ebook: "E-Book (Digital)",
  "e-book": "E-Book (Digital)",
  audio: "Audiobook",
  audiobook: "Audiobook",
  course: "Online Course",
  physical: "Physical Book",
};

export function normalizeFormat(format) {
  return (format || "").toString().trim().toLowerCase();
}

export function getFormatLabel(format) {
  const key = normalizeFormat(format);
  if (!key) return "Format TBC";
  return FORMAT_LABELS[key] || format;
}

export function isPhysicalFormat(format) {
  const key = normalizeFormat(format);
  return ["hardcover", "paperback", "physical"].includes(key);
}

export function isDigitalFormat(format) {
  const key = normalizeFormat(format);
  return ["ebook", "e-book", "audio", "audiobook", "course"].includes(key);
}

export default function FormatBadge({ format, className = "" }) {
  const key = normalizeFormat(format);
  const styles = FORMAT_STYLES[key] || "bg-slate-100 text-slate-700 border-slate-200";

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${styles} ${className}`}
    >
      {getFormatLabel(format)}
    </span>
  );
}
